import { fetchPerformanceAssessmentEntryById } from '@/api/resources/performanceAssessmentEntry.api';
import { useToast } from '@/composables/useToast';

/** Fetch only the requested entry when the dialog opens or reloads after an edit. */
export function usePerformanceAssessmentEntryDetail() {
  const { catchError } = useToast();
  const getPerformanceAssessmentEntryById = (id: number) =>
    catchError(() => fetchPerformanceAssessmentEntryById({ id }));

  return { getPerformanceAssessmentEntryById };
}
